import { Box, Group, Loader, Paper, Skeleton, Stack } from '@mantine/core';

/** Skeleton shown while initial messages are loading. */
export function MessageSkeleton() {
  return (
    <Stack spacing="xs">
      {[false, true, false, true, false].map((isRight, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            justifyContent: isRight ? 'flex-end' : 'flex-start',
            width: '100%',
          }}
        >
          <Skeleton height={40} width={isRight ? '55%' : '70%'} radius="md" />
        </Box>
      ))}
    </Stack>
  );
}

/** Skeleton shown while older messages are being paginated in. */
export function PaginationSkeleton() {
  return (
    <Stack spacing="xs" py="xs">
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Loader variant="dots" size="sm" color="gray" />
      </Box>
      <Box
        sx={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
      >
        <Skeleton height={36} width="60%" radius="md" />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <Skeleton height={36} width="45%" radius="md" />
      </Box>
    </Stack>
  );
}

/** Skeleton shown while the conversations list is loading. */
export function ConversationSkeleton() {
  return (
    <Stack spacing="xs">
      {[1, 2, 3, 4, 5].map((i) => (
        <Paper key={i} withBorder p="xs">
          <Group position="apart" noWrap>
            <Group spacing="xs" noWrap sx={{ flex: 1 }}>
              <Skeleton height={38} width={38} radius="xl" />
              <Stack spacing={4} sx={{ flex: 1 }}>
                <Skeleton height={14} width="60%" radius="md" />
                <Skeleton height={12} width="80%" radius="md" />
              </Stack>
            </Group>
            <Skeleton height={12} width={30} radius="md" />
          </Group>
        </Paper>
      ))}
    </Stack>
  );
}
